/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetIntegrationConfigRequest {
    integrationId: string;
    sessionId?: string;
}

export interface GetProcessedSchemaRequest {
    integrationId: string;
    sessionId?: string;
}

export interface GetProcessedSchemaBySlugRequest {
    schemaSlug: string;
}

/**
 * IntegrationSchemaApi - interface
 * 
 * @export
 * @interface IntegrationSchemaApiInterface
 */
export interface IntegrationSchemaApiInterface {
    /**
     * Retrieve integration-specific configuration variables
     * @summary Get integration configuration
     * @param {string} integrationId Integration ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationSchemaApiInterface
     */
    getIntegrationConfigRaw(requestParameters: GetIntegrationConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieve integration-specific configuration variables
     * Get integration configuration
     */
    getIntegrationConfig(requestParameters: GetIntegrationConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieve integration schema with variable substitution applied
     * @summary Get processed integration schema
     * @param {string} integrationId Integration ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationSchemaApiInterface
     */
    getProcessedSchemaRaw(requestParameters: GetProcessedSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieve integration schema with variable substitution applied
     * Get processed integration schema
     */
    getProcessedSchema(requestParameters: GetProcessedSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieve integration schema by slug with variable substitution applied
     * @summary Get processed integration schema by slug
     * @param {string} schemaSlug Schema slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationSchemaApiInterface
     */
    getProcessedSchemaBySlugRaw(requestParameters: GetProcessedSchemaBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieve integration schema by slug with variable substitution applied
     * Get processed integration schema by slug
     */
    getProcessedSchemaBySlug(requestParameters: GetProcessedSchemaBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationSchemaApi extends runtime.BaseAPI implements IntegrationSchemaApiInterface {

    /**
     * Retrieve integration-specific configuration variables
     * Get integration configuration
     */
    async getIntegrationConfigRaw(requestParameters: GetIntegrationConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getIntegrationConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/wizard-schemas/{integrationId}/config`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve integration-specific configuration variables
     * Get integration configuration
     */
    async getIntegrationConfig(requestParameters: GetIntegrationConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getIntegrationConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve integration schema with variable substitution applied
     * Get processed integration schema
     */
    async getProcessedSchemaRaw(requestParameters: GetProcessedSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getProcessedSchema().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/wizard-schemas/{integrationId}`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve integration schema with variable substitution applied
     * Get processed integration schema
     */
    async getProcessedSchema(requestParameters: GetProcessedSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getProcessedSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve integration schema by slug with variable substitution applied
     * Get processed integration schema by slug
     */
    async getProcessedSchemaBySlugRaw(requestParameters: GetProcessedSchemaBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['schemaSlug'] == null) {
            throw new runtime.RequiredError(
                'schemaSlug',
                'Required parameter "schemaSlug" was null or undefined when calling getProcessedSchemaBySlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/wizard-schemas/by-slug/{schemaSlug}`;
        urlPath = urlPath.replace(`{${"schemaSlug"}}`, encodeURIComponent(String(requestParameters['schemaSlug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve integration schema by slug with variable substitution applied
     * Get processed integration schema by slug
     */
    async getProcessedSchemaBySlug(requestParameters: GetProcessedSchemaBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getProcessedSchemaBySlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
